import { request } from "../../../app/api-client/ApiClient";

/**
 * Metodo para obtener las maquinas asocuadas a un admin
 * @param {Integer} idAdmin 
 */
export function listSuper(dispatch, id) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/supervisor/list/evbi/${id}`,
		method: "GET",
	}, dispatch);
}
export function createNewSupervisor(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/supervisor/crear`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}

export function updateSupervisor(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/supervisor/actualizar`;
	return request({
		url: url,
		method: "PUT",
		body: JSON.stringify(Request),
	}, dispatch);
}
export function deleteSupervisor(dispatch, id) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/supervisor/eliminar/${id}`;
	return request({
		url: url,
		method: "DELETE",
		body: JSON.stringify(Request),
	}, dispatch);
}
